export const Fb = ({ size = 24 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12C4 16 6.9 19.3 10.7 19.9V14.3H8.7V12H10.7V10.2C10.7 8.2 11.9 7.1 13.7 7.1C14.6 7.1 15.5 7.3 15.5 7.3V9.3H14.5C13.5 9.3 13.2 9.9 13.2 10.5V12H15.4L15 14.3H13.1V20C17.1 19.4 20 16 20 12Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const LinkedIn = ({ size = 24 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M7.60001 20H4.2V9.3H7.60001V20ZM5.9 7.8C4.8 7.8 4 7 4 5.9C4 4.8 4.9 4 5.9 4C7 4 7.8 4.8 7.8 5.9C7.8 7 7 7.8 5.9 7.8ZM20 20H16.6V14.2C16.6 12.5 15.9 12 14.9 12C13.9 12 12.9 12.8 12.9 14.3V20H9.5V9.3H12.7V10.8C13 10.1 14.2 9 15.9 9C17.8 9 19.8 10.1 19.8 13.4V20H20Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const Instagram = ({ size = 24 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12.0004 5.44581C14.1208 5.44581 14.41 5.44581 15.2775 5.44581C16.0486 5.44581 16.4341 5.63859 16.7233 5.73497C17.1088 5.92774 17.398 6.02413 17.6871 6.31328C17.9763 6.60244 18.169 6.8916 18.2654 7.27714C18.3618 7.5663 18.4582 7.95184 18.5546 8.72292C18.5546 9.59039 18.5546 9.78316 18.5546 12C18.5546 14.2169 18.5546 14.4097 18.5546 15.2771C18.5546 16.0482 18.3618 16.4338 18.2654 16.7229C18.0727 17.1085 17.9763 17.3976 17.6871 17.6868C17.398 17.9759 17.1088 18.1687 16.7233 18.2651C16.4341 18.3615 16.0486 18.4579 15.2775 18.5542C14.41 18.5542 14.2172 18.5542 12.0004 18.5542C9.7835 18.5542 9.59073 18.5542 8.72326 18.5542C7.95217 18.5542 7.56663 18.3615 7.27748 18.2651C6.89193 18.0723 6.60278 17.9759 6.31362 17.6868C6.02446 17.3976 5.83169 17.1085 5.73531 16.7229C5.63892 16.4338 5.54254 16.0482 5.44615 15.2771C5.44615 14.4097 5.44615 14.2169 5.44615 12C5.44615 9.78316 5.44615 9.59039 5.44615 8.72292C5.44615 7.95184 5.63892 7.5663 5.73531 7.27714C5.92808 6.8916 6.02446 6.60244 6.31362 6.31328C6.60278 6.02413 6.89193 5.83136 7.27748 5.73497C7.56663 5.63859 7.95217 5.5422 8.72326 5.44581C9.59073 5.44581 9.87989 5.44581 12.0004 5.44581ZM12.0004 4.00003C9.7835 4.00003 9.59073 4.00003 8.72326 4.00003C7.85579 4.00003 7.27748 4.1928 6.79555 4.38557C6.31362 4.57834 5.83169 4.8675 5.34976 5.34943C4.86784 5.83136 4.67507 6.2169 4.38591 6.79521C4.19314 7.27714 4.09675 7.85545 4.00037 8.72292C4.00037 9.59039 4.00037 9.87955 4.00037 12C4.00037 14.2169 4.00037 14.4097 4.00037 15.2771C4.00037 16.1446 4.19314 16.7229 4.38591 17.2049C4.57868 17.6868 4.86784 18.1687 5.34976 18.6506C5.83169 19.1326 6.21723 19.3253 6.79555 19.6145C7.27748 19.8073 7.85579 19.9036 8.72326 20C9.59073 20 9.87989 20 12.0004 20C14.1208 20 14.41 20 15.2775 20C16.1449 20 16.7233 19.8073 17.2052 19.6145C17.6871 19.4217 18.169 19.1326 18.651 18.6506C19.1329 18.1687 19.3257 17.7832 19.6148 17.2049C19.8076 16.7229 19.904 16.1446 20.0004 15.2771C20.0004 14.4097 20.0004 14.1205 20.0004 12C20.0004 9.87955 20.0004 9.59039 20.0004 8.72292C20.0004 7.85545 19.8076 7.27714 19.6148 6.79521C19.4221 6.31328 19.1329 5.83136 18.651 5.34943C18.169 4.8675 17.7835 4.67473 17.2052 4.38557C16.7233 4.1928 16.1449 4.09642 15.2775 4.00003C14.41 4.00003 14.2172 4.00003 12.0004 4.00003Z'
        fill='#4B4C4D'
      />
      <path
        d='M12.0004 7.85545C9.68711 7.85545 7.85579 9.68678 7.85579 12C7.85579 14.3133 9.68711 16.1446 12.0004 16.1446C14.3136 16.1446 16.1449 14.3133 16.1449 12C16.1449 9.68678 14.3136 7.85545 12.0004 7.85545ZM12.0004 14.6988C10.5546 14.6988 9.30157 13.5422 9.30157 12C9.30157 10.5542 10.4582 9.30124 12.0004 9.30124C13.4462 9.30124 14.6992 10.4579 14.6992 12C14.6992 13.4458 13.4462 14.6988 12.0004 14.6988Z'
        fill='#4B4C4D'
      />
      <path
        d='M16.2413 8.72292C16.7737 8.72292 17.2052 8.29139 17.2052 7.75907C17.2052 7.22674 16.7737 6.79521 16.2413 6.79521C15.709 6.79521 15.2775 7.22674 15.2775 7.75907C15.2775 8.29139 15.709 8.72292 16.2413 8.72292Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const YuTuBe = ({ size = 24 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M19.6 8.10006C19.4 7.40006 18.9 6.90006 18.2 6.70006C17 6.40006 11.9 6.40005 11.9 6.40005C11.9 6.40005 6.90001 6.40006 5.60001 6.70006C4.90001 6.90006 4.4 7.40006 4.2 8.10006C4 9.40006 4 12.0001 4 12.0001C4 12.0001 4 14.6001 4.3 15.9001C4.5 16.6001 5 17.1001 5.7 17.3001C6.9 17.6001 12 17.6001 12 17.6001C12 17.6001 17 17.6001 18.3 17.3001C19 17.1001 19.5 16.6001 19.7 15.9001C20 14.6001 20 12.0001 20 12.0001C20 12.0001 20 9.40006 19.6 8.10006ZM10.4 14.4001V9.60006L14.6 12.0001L10.4 14.4001Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};

export const X = ({ size = 24 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M6.04139 6.42856H9.86453L12.5795 10.1474L15.8739 6.42856H17.0781L13.1232 10.8919L18 17.5714H14.1778L11.0273 13.2568L7.20414 17.5714H6L10.4835 12.5123L6.04139 6.42856ZM7.88523 7.35713L14.6802 16.6428H16.1562L9.36124 7.35713H7.88523Z'
        fill='#4B4C4D'
      />
    </svg>
  );
};
